import type { Component } from 'vue';

export const FilterComponentNames = {
	UserPicker: 'UserPicker',
	UserPreview: 'UserPreview',
} as const;

export type FilterComponentName = keyof typeof FilterComponentNames;

const registry = new Map<FilterComponentName, Component>();

export function registerFilterComponent(name: FilterComponentName, component: Component): void {
	registry.set(name, component);
}

export function resolveFilterComponent(name: FilterComponentName | undefined): Component | undefined {
	return name ? registry.get(name) : undefined;
}
